import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { StatusTrackingDto } from '../../../shared/modules/status-tracking/dtos/status-tracking.dto';
import { VehicleFeatureItemDto } from '../../../shared/modules/vehicle-feature-items/dtos/vehicle-feature-item.dto';
import { VehicleMakeSearchDto } from '../../../shared/modules/vehicle-makes';
import { VehicleModelSearchDto } from '../../../shared/modules/vehicle-models';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';
import { LocationSearchDto } from '../../locations';
import { SupplierSearchDto } from '../../suppliers/dtos/supplier-search.dto';
import { FuelConsumptionUnitEnum } from '../../shared/enums/fuel-consumption-unit.enum';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleCategorySearchDto } from '../../vehicle-categories';
import { VehicleColorListDto } from '../../vehicle-colors/dtos/vehicle-color-list.dto';
import { VehicleOdometerTrackingDto } from '../../vehicle-odometer-tracking/dtos/vehicle-odometer-tracking.dto';
import { VehicleAllocationEnum } from '../enums/vehicle-allocation.enum';
import { VehicleBodyTypeEnum } from '../enums/vehicle-body-type.enum';
import { VehicleDriveTrainTypeEnum } from '../enums/vehicle-drive-train-type.enum';
import { VehicleElectricBatteryTypeEnum } from '../enums/vehicle-electric-battery-type.enum';
import { VehicleEmissionsUnitCO2Enum } from '../enums/vehicle-emissions-unit-co2.enum';
import { VehicleEngineSizeUnitEnum } from '../enums/vehicle-engine-size-unit.enum';
import { VehicleFuelTankCapacityUnitEnum } from '../enums/vehicle-fuel-tank-capacity-unit.enum';
import { VehicleFuelTypeEnum } from '../enums/vehicle-fuel-type.enum';
import { VehicleOdometerUnitEnum } from '../enums/vehicle-odometer-unit.enum';
import { VehiclePowerPlantTypeEnum } from '../enums/vehicle-power-plant-type.enum';
import { VehicleStatusEnum } from '../enums/vehicle-status.enum';
import { VehicleSteeringPositionEnum } from '../enums/vehicle-steering-position.enum';
import { VehicleTransmissionTypeEnum } from '../enums/vehicle-transmission-type.enum';
import { VehicleTypeEnum } from '../enums/vehicle-type.enum';

/**
 * Vehicle DTO for records
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleRecordDto extends BaseDto {
  uuid!: string;
  vin!: string;
  engineNumber?: string | null;
  licensePlate?: string | null;
  odometerUnit?: VehicleOdometerUnitEnum | null;
  lastOdometerTracking?: VehicleOdometerTrackingDto | null;
  status!: VehicleStatusEnum;
  notes?: string | null;
  type!: VehicleTypeEnum;
  registeredAt?: Date | null;
  deregisteredAt?: Date | null;
  makeId?: number | null;
  make?: VehicleMakeSearchDto | null;
  modelId?: number | null;
  model?: VehicleModelSearchDto | null;
  year?: number | null;
  seats?: number | null;
  series?: string | null;
  trim?: string | null;
  manufacturedAt?: Date | null;
  exteriorColorId?: number | null;
  exteriorColor?: VehicleColorListDto | null;
  interiorColorId?: number | null;
  interiorColor?: VehicleColorListDto | null;
  bodyType!: VehicleBodyTypeEnum;
  fuelType?: VehicleFuelTypeEnum | null;
  steeringPosition?: VehicleSteeringPositionEnum | null;
  doors?: number | null;
  transmissionType?: VehicleTransmissionTypeEnum | null;
  driveTrainType?: VehicleDriveTrainTypeEnum | null;
  primaryPowerPlantType?: VehiclePowerPlantTypeEnum | null;
  secondaryPowerPlantType?: VehiclePowerPlantTypeEnum | null;
  engineSizeUnit?: VehicleEngineSizeUnitEnum | null;
  engineSize?: number | null;
  engineOutput?: number | null;
  engineTurbine?: boolean | null;
  averageEmissionsCO2?: number | null;
  emissionsUnitCO2?: VehicleEmissionsUnitCO2Enum | null;
  averageFuelConsumption?: number | null;
  fuelConsumptionUnit?: FuelConsumptionUnitEnum | null;
  fuelTankCapacity?: number | null;
  fuelTankCapacityUnit?: VehicleFuelTankCapacityUnitEnum | null;
  averageElectricConsumption?: number | null;
  electricBatteryCapacity?: number | null;
  electricBatteryVoltage?: number | null;
  electricBatteryType?: VehicleElectricBatteryTypeEnum | null;
  electricMotorOutput?: number | null;
  electricMotorRangeFrom?: number | null;
  electricMotorRangeTo?: number | null;
  allocation!: VehicleAllocationEnum;
  supplierId?: number | null;
  supplier?: SupplierSearchDto | null;
  locationId?: number | null;
  location?: LocationSearchDto | null;
  vehicleCategoryId?: number | null;
  vehicleCategory?: VehicleCategorySearchDto | null;
  purchasedAt?: Date | null;
  purchaseListPrice?: number | null;
  purchasePaidPrice?: number | null;
  soldAt?: Date | null;
  saleAskPrice?: number | null;
  saleSoldPrice?: number | null;
  statusTracking?: StatusTrackingDto<VehicleStatusEnum>[] | null;
  featureItems?: VehicleFeatureItemDto[] | null;
  tags?: TagListDto[] | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
  hasGpsTracker?: boolean | null;
  gpsTrackerUuid?: string | null;
  makeFull?: string | null;
  isTransferable?: boolean | null;
}
